import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'
import { BrowserView } from 'react-device-detect'

import { Button, FlexContainer, Text, Icon } from 'components'

import './inserts.scss'

const updateInsertsToolbarPosition = (
	insertsToolbarRef,
	entryRef,
	value = null
) => {
	const insertsToolbar = insertsToolbarRef.current
	const entry = entryRef.current
	let el = document.querySelectorAll('.has-focus')[0]

	if (
		value &&
		value.document.text === '' &&
		!value.document.nodes.filter(n => n.type !== 'paragraph').size
	) {
		el = document.querySelectorAll('.o-editor p:first-of-type')[0]
	}

	if (el) {
		const rect = el.getBoundingClientRect()
		const entryScrollTop = entry.parentNode.parentNode.scrollTop

		insertsToolbar.style.top = `${parseInt(rect.top, 10) +
			entryScrollTop -
			entry.offsetTop}px`
	}
}

const updateInsertsToolbar = (insertsToolbarRef, entryRef, value) => {
	const insertsToolbar = insertsToolbarRef.current

	if (
		(value.focusBlock &&
			insertsToolbar &&
			value.document.getParent(value.focusBlock.key).object ===
				'document' &&
			window.getSelection().isCollapsed &&
			value.focusBlock.text.length === 0 &&
			value.focusBlock.type === 'paragraph') ||
		(value.document.text === '' &&
			!value.document.nodes.filter(n => n.type !== 'paragraph').size)
	) {
		setTimeout(() => {
			if (
				window.getSelection &&
				document.createRange &&
				typeof document.createRange().getBoundingClientRect !==
					'undefined'
			) {
				const sel = window.getSelection()

				if (sel.rangeCount > 0) {
					let el = document.querySelectorAll('.has-focus')[0]

					if (
						value &&
						value.document.text === '' &&
						!value.document.nodes.filter(
							n => n.type !== 'paragraph'
						).size
					) {
						el = document.querySelectorAll(
							'.o-editor p:first-of-type'
						)[0]
					}

					if (el) {
						updateInsertsToolbarPosition(
							insertsToolbarRef,
							entryRef
						)
						insertsToolbar.classList.add('is-visible')
					} else {
						insertsToolbar.classList.remove('is-visible')
					}
				}
			}
		}, 1)
	} else if (
		value.focusBlock &&
		insertsToolbar &&
		insertsToolbar.classList.contains('is-visible')
	) {
		insertsToolbar.classList.remove('is-visible')
	}
}

class InsertsToolbarComponent extends PureComponent {
	insertLocalImageFile = event => {
		event.preventDefault()

		const { editor, id, t } = this.props
		const file = document.getElementById('image-input')

		for (let i = 0; i < file.files.length; i += 1) {
			if (file.files[i].type.match('image.*')) {
				editor.insertFile(file.files[i], id)
			} else {
				alert(t('editor.no_image'))
			}
		}

		event.target.value = ''
	}

	insertLocalFile = event => {
		event.preventDefault()

		const { editor, id } = this.props
		const file = document.getElementById('file-input')

		for (let i = 0; i < file.files.length; i += 1) {
			editor.insertFile(file.files[i], id, true)
		}

		event.target.value = ''
	}

	componentDidMount() {
		const {
			entry,
			editor: { value },
			forwardedRef,
		} = this.props

		// console.log('componentDidMount', value)

		if (
			value.document.text === '' &&
			!value.document.nodes.filter(n => n.type !== 'paragraph').size
		) {
			const el = document.querySelectorAll('.o-editor p:first-of-type')[0]

			if (el) {
				const rect = el.getBoundingClientRect()
				const insertsToolbar = forwardedRef.current
				const entryScrollTop =
					entry.current.parentNode.parentNode.scrollTop

				insertsToolbar.style.top = `${parseInt(rect.top, 10) +
					entryScrollTop -
					entry.current.offsetTop}px`
				insertsToolbar.classList.add('is-visible')
			}
		}
	}

	render() {
		const { editor, forwardedRef, t } = this.props

		return (
			<div className="c-inserts" ref={forwardedRef}>
				<BrowserView renderWithFragment>
					<FlexContainer>
						<Text color="light" size="inherit" inline>
							<span
								className="c-inserts__command"
								dangerouslySetInnerHTML={{
									__html: t('editor.type_to_add_elements'),
								}}
							/>
						</Text>
						<Button
							icon={
								<Icon
									name="placeholder-quickcommands"
									className="c-inserts__icon"
								/>
							}
							layout="text"
							onMouseDown={e => {
								e.preventDefault()

								editor
									.insertText('/')
									.moveAnchorToEndOfText()
									.focus()
							}}
						/>
					</FlexContainer>
				</BrowserView>

				<input
					id="image-input"
					type="file"
					onChange={this.insertLocalImageFile}
					multiple="multiple"
					className="u-visually-hidden"
				/>
				<input
					id="file-input"
					type="file"
					onChange={this.insertLocalFile}
					multiple="multiple"
					className="u-visually-hidden"
				/>
			</div>
		)
	}
}

const InsertsToolbarComponentWrapper = translate()(InsertsToolbarComponent)
const InsertsToolbar = React.forwardRef((props, ref) => (
	<InsertsToolbarComponentWrapper {...props} forwardedRef={ref} />
))

export { InsertsToolbar, updateInsertsToolbar, updateInsertsToolbarPosition }
